/// <amd-module name="Wit/Search/SearchResult" />
import React = require("react");
import { ISearchResult, ISearchStatus } from "VSS/Platform/Search";

export interface IWorkitemSearchResultProps {
    searchStatus?: ISearchStatus;
}

export class WorkitemSearchResultComponent extends React.Component<IWorkitemSearchResultProps, {}> {
    public render(): JSX.Element {
        const searchResult = this.props.searchStatus && this.props.searchStatus.searchResult && this.props.searchStatus.searchResult.value;

        return (
            <div className="search-provider flex flex-column flex-grow">
                <div className="search-filter-bar">Place WIT filter bar components here ...</div>
                <div className="search-results flex flex-column flex-grow">
                    {
                        (!this.props.searchStatus) ? (
                            <div className="search-view-information-area">
                                <div className="search-view-information-title">Welcome to Workitem Search!</div>
                                <div className="search-view-information-summary">
                                    Find workitems in your Azure DevOps Services account
                                    <br />
                                    <br />
                                    Here are some ways to find the workitems you want:
                                    <ul className="search-view-information-examples">
                                        <li>Example 1 ...</li>
                                        <li>Example 2 ...</li>
                                        <li>Example 3 ...</li>
                                    </ul>
                                    <p>
                                        <span>For more ways to search, see the </span>
                                        <a href="https://go.microsoft.com/fwlink/?LinkId=698587&amp;clcid=0x409" id="search-hub-helplink" target="_blank">help page</a><span>. </span>
                                        <span>Send your feedback to </span>
                                        <a href="mailto:vsosrch@microsoft.com" id="search-hub-feedbacklink" target="_top">vsosrch@microsoft.com</a>
                                    </p>
                                </div>
                            </div>
                        ) : (!searchResult) ? (
                            <span>Waiting on results ...</span>
                        ) : (searchResult.matches && searchResult.matches.length) ? (
                            <ul>
                                {
                                    searchResult.matches.map((match, index) => {
                                        return <li key={index}>{match.render()}</li>;
                                    })
                                }
                            </ul>
                        ) : (
                            <span>No matches found</span>
                        )
                    }
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        this.props.searchStatus && this.props.searchStatus.searchResult.subscribe(this.onSearchResultSet);
    }

    public componentWillReceiveProps(newProps: IWorkitemSearchResultProps): void {
        this.props.searchStatus && this.props.searchStatus.searchResult.unsubscribe(this.onSearchResultSet);
        newProps.searchStatus && newProps.searchStatus.searchResult.subscribe(this.onSearchResultSet);
    }

    public componentWillUnmount(): void {
        this.props.searchStatus && this.props.searchStatus.searchResult.unsubscribe(this.onSearchResultSet);
    }

    private onSearchResultSet = (searchResult: ISearchResult): void => {
        this.forceUpdate();
    }
}
